import { useEffect, useState } from 'react';
import { useMeasure } from 'utilities/useMeasure';

export const useBlockSize = (categories: number) => {
    const [result, setResult] = useState('40px');

    const { width } = useMeasure();

    useEffect(() => {
        if (width > 0) {
            const availableWidth = width - 200;
            const widthPerCategory = availableWidth / categories - 90;
            const widthPerBlock = widthPerCategory / 11;

            if (widthPerBlock < 20) return setResult('20px');
            if (widthPerBlock > 40) return setResult('40px');
            setResult(`${widthPerBlock}px`);
        }
    }, [width]);

    return result;
};
